import { Chain, ChainID, IBlockchainEntity } from '@ankr.com/chains-list';
import { IUsageTopElement } from 'multirpc-sdk';

import { isObjectEmpty } from 'modules/common/utils/isObjectEmpty';
import { getChainIDsByPaths } from 'modules/chains/utils/getChainIDsByPaths';
import { getChainBySubchainID } from 'modules/chains/utils/getChainBySubchainID';
import { getPathsByChainID } from 'modules/chains/utils/getPathsByChainID';

import { sumBlockchainsCountsByChainPaths } from './sumBlockchainsCountsByChainPaths';

export type AggregatedBlockchainsCountsByChainID = Record<ChainID, number>;

const defaultAggregation = {} as AggregatedBlockchainsCountsByChainID;

interface AggregateBlockchainsCountsByChainIDParams {
  allChainsPaths: string[];
  blockchains: IBlockchainEntity[];
  blockchainsCounts: IUsageTopElement[];
  formattedBlockchains: Chain[];
}

export const aggregateBlockchainsCountsByChainID = ({
  allChainsPaths,
  blockchains,
  blockchainsCounts,
  formattedBlockchains,
}: AggregateBlockchainsCountsByChainIDParams) => {
  const result = blockchainsCounts.reduce((aggregation, { name }) => {
    const [currentChainId] = getChainIDsByPaths({
      blockchains,
      paths: [name],
    });

    const currentChainMainId = getChainBySubchainID({
      chainID: currentChainId as ChainID,
      chains: formattedBlockchains,
    })?.id;

    if (!currentChainMainId) {
      return aggregation;
    }

    const subchainPaths = getPathsByChainID({
      allChainsPaths,
      chainID: currentChainMainId,
      chains: formattedBlockchains,
    });

    const aggregatedStatsByChain = sumBlockchainsCountsByChainPaths({
      blockchainsCounts,
      chainPaths: subchainPaths,
    });

    aggregation[currentChainMainId] = aggregatedStatsByChain;

    return aggregation;
  }, {} as AggregatedBlockchainsCountsByChainID);

  return isObjectEmpty(result) ? defaultAggregation : result;
};
